import { Component } from "react";

class SearchField extends Component {
  constructor(props) {
    super(props);
    this.state = { value: this.props.defaultValue };
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
    this.props.handleChange(event);
  }

  render() {
    return (
      <input
        name="courseSearch"
        id="courseSearch"
        placeholder="Saisissez votre recherche"
        className="p-2 text-small sm:w-80 w-full flex-grow rounded-md border-0 placeholder-gray-lighter placeholder-italic text-gray-darkest focus:ring-orange focus:outline-none"
        defaultValue={this.props.defaultValue}
        onChange={this.props.handleChange}
        onFocus={this.props.onFocus}
      />
    );
  }
}

export default SearchField;
